import { Box } from "@mui/joy";
import { ProfileFieldGroup } from "../profileFields";
import FieldGrid from "./FieldGrid";
import SectionCard from "./SectionCard";

type FieldGroupsTabProps = {
  groups: ProfileFieldGroup[];
};

// masonry-style columns so cards of different heights pack without gaps
function FieldGroupsTab({ groups }: FieldGroupsTabProps) {
  return (
    <Box sx={{ columns: { xs: 1, lg: 2 }, columnGap: "20px" }}>
      {groups.map((group) => (
        <Box key={group.id} sx={{ breakInside: "avoid", mb: 2.5 }}>
          <SectionCard title={group.title} icon={group.icon}>
            <FieldGrid fields={group.fields} />
          </SectionCard>
        </Box>
      ))}
    </Box>
  );
}

export default FieldGroupsTab;
